<template>
  <div>
    <learnCardBind :value.sync="showLearnCardBind"></learnCardBind>
    <div class="nupmrm_case">
      <div class="npm_caseDiv9" style="padding-left: 180px;height:38px;">
        <div class="npm_caseDiv9_left"><span>共<label>{{searchForm.total}}</label>场考试</span>考试状态：</div>
        <div class="npm_caseDiv9_right">
          <ul class="i_nav-012">
            <el-radio-group v-model="searchForm.testState" @change="searchList" size="medium">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="1">可开考</el-radio-button>
              <el-radio-button label="0">未开始</el-radio-button>
              <el-radio-button label="2">已完成</el-radio-button>
              <el-radio-button label="3">已结束</el-radio-button>
            </el-radio-group>
          </ul>
          <el-tooltip class="item" effect="dark" content="如果您是刚注册的账号，系统需要花时间来认识您哟~请十分钟后来查找您的考试。 尝试刷新页面吧！" placement="top">
            <span style="padding-left: 30px;color:#ff5300;">找不到考试 <i class="el-icon-question"></i> </span>
          </el-tooltip>
        </div>
      </div>
      <div class="npm_caseDiv9" style="height:38px; text-align:left;padding-left: 0;" >
        <div class="npm_caseDiv9_right">
          <span v-show="bindType == 2">培训班：</span><el-select v-model="searchForm.trainingId" size="small" style="width:20%; margin-right: 100px;" v-show="bindType == 2">
          <el-option  label="全部" value=""></el-option>
          <el-option
            v-for="item in nameReturn"
            :label="item.name"
            :value="item.id"
            :key="item.id">
          </el-option>
        </el-select>
          考试名称：<el-input v-model.trim="searchForm.keyWord" placeholder="按考试名称关键字搜索"  style="width:20%; margin-right: 100px;" size="small"></el-input>
          <input type="button" value="搜索" id="search" @click="searchList" />
        </div>
      </div>
    </div>
    <div class="nupmrm_content">
      <el-table :data="examListInit" highlight-current-row v-loading="listLoading" style="width: 100%;" border size="mini"> <!--@sort-change="sortExamList" 排序需要的-->
        <el-table-column prop="name" label="考试名称" width="310" show-overflow-tooltip ></el-table-column>
        <el-table-column prop="examScore" label="成绩" width="65" ></el-table-column> <!--sortable="custom"  排序需要的-->
        <el-table-column prop="examCount" label="考试次数" width="75" :formatter="formatCount" ></el-table-column>
        <el-table-column prop="endTime" label="考试有效期"  width="275">
          <template slot-scope="scope">
            <span>{{scope.row.startTime}}至{{scope.row.endTime}}<img v-if="serverTime >scope.row.endTime" src='../assets/img-4/kaoshijieshu.png' width='54' height='26' border='0' class='new_pic_yjs' /></span>
          </template>
        </el-table-column>
        <el-table-column prop="paperScore" label="总分" width="55"></el-table-column>
        <el-table-column prop="examMinutes" label="考试时长" width="75"></el-table-column>
        <el-table-column prop="examState" label="考试状态" width="75" :formatter="formatState" ></el-table-column>
        <el-table-column prop="terminalType" label="考试方式" width="85" :formatter="formatType" ></el-table-column>
        <el-table-column prop="answerAnnounce" label="答案" width="65" >
          <template slot-scope="scope">
            <span  v-if="scope.row.checkAnswerFlag ==0">{{scope.row.answerAnnounce}}</span>  <!--显示策略-->
            <el-button type="primary" size="small" @click="viewExamAnswer(scope.$index, scope.row)"  v-if="scope.row.checkAnswerFlag ==1">查看</el-button> <!--显示查看按钮-->
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="beginExam(scope.$index, scope.row)" v-if="scope.row.userStatus != 1" :disabled=" serverTime >scope.row.endTime || scope.row.terminalType == 2 || scope.row.examState == 0 || scope.row.examState == 3 || scope.row.examState == 2 " >开始考试</el-button>
            <el-button type="danger" size="mini" @click="beginExam(scope.$index, scope.row)" v-if="scope.row.userStatus == 1"  :disabled=" serverTime >scope.row.endTime || scope.row.terminalType == 2 || scope.row.examState == 0 || scope.row.examState == 3 " >开始考试</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-col :span="24" class="toolbar" style="padding-top: 12px;">
        <el-pagination layout="total, prev, pager, next" @current-change="handleExamCurrentChange" :page-size="searchForm.pageSize" :total="searchForm.total" style="float:right;" :current-page="searchForm.page">
        </el-pagination>
      </el-col>
    </div>
  </div>
</template>

<style>

</style>

<script>
  import util from '../common/js/util'
  import { mapGetters } from 'vuex'
  import jsonp from 'jsonp'
  import md5 from 'crypto-js/md5'
  import { validateTrainingExam,getServerNowTime,getBeginExamUrl,listStudentTraining,getUserCenterExamLists,validateUserCreditBindingTerm,getViewExamAnswerUrl } from '../api/api'
  import learnCardBind from '../components/LearnCardBind'

  var examWindow;
  export default {
    components: {
      learnCardBind
    },

    props: {
      bindType: {
        type: String,
        required: false
      }
    },
    data () {
      return {
        showLearnCardBind : false,
        examListInit:[],
        listLoading:false,
        activeName1:'first',
        serverTime:'',
        nameReturn:[],
        searchForm:{
          page: 1,//当前页数
          pageSize: 10,//每页显示条目个数
          total: 0, //总条目数
          testState:'1',
          psort:'',
          keyWord:'',
          userId:'',
          trainingId:'',
          bindType:''
        },
      }
    },
    computed: {
      ...mapGetters([
        'userInfo'
      ])
    },
    methods: {

      searchList(){
        this.searchForm.page = 1;
        this.listExamInit();
      },

      getTrainingNameList(){
        listStudentTraining({//获得学员所有培训班
          userId: this.userInfo.id,
          excludeExpire: false,
          trainingWay:'1'
        }).then((response) => {
          this.nameReturn = response.data.data.list
        })
      },

      listExamInit(){
        if(this.$storejs.get(process.env.APPKEY + 'token') == undefined){
          this.$alert('请刷新检查登陆状态', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push("/");
            }
          });
          return false;
        }

        this.listLoading = true;

        var param = {userId:this.userInfo.id,page:this.searchForm.page,pageSize:this.searchForm.pageSize,examState:this.searchForm.testState,bindType:this.bindType,trainingId:this.searchForm.trainingId,examName:this.searchForm.keyWord,psort:this.searchForm.psort};
        getUserCenterExamLists(param).then((res) => {
          this.searchForm.total = res.data.data.total;
//          for(let sn in res.data.data.list){
//            this.$set(this.examListInit,sn,res.data.data.list[sn])
//          }
          this.examListInit = res.data.data.list;
          this.serverTime = this.$moment(res.data.ts).format('YYYY-MM-DD HH:mm:ss');// util.formatDate.format(new Date(data.ts),'yyyy-MM-dd hh:mm:ss');
          this.listLoading = false;
        }).catch(() => {
          this.listLoading = false
          this.$message({
            type: 'info',
            message: '加载失败！'
          });
        });

        /*jsonp(process.env.EXAM_API_URL + 'v2/exams/user/' + this.userInfo.id + '?' +'page=' +
         this.searchForm.page+'&pageSize=' + this.searchForm.pageSize+'&examState=' + this.searchForm.testState+'&bindType='+this.bindType+'&trainingId='+this.searchForm.trainingId
         +'&examName=' + this.searchForm.keyWord
         , function (err, data) {
         this.searchForm.total = data.data.total;
         this.examListInit = data.data.list;
         this.serverTime = this.$moment(data.ts).format('YYYY-MM-DD HH:mm:ss');// util.formatDate.format(new Date(data.ts),'yyyy-MM-dd hh:mm:ss');
         this.listLoading = false;
         });*/
      },

      handleExamCurrentChange(val){
        this.searchForm.page = val;
        this.listExamInit();
      },

      sortExamList({ column, prop, order }){
        if(order == 'ascending'){  //正序
          this.searchForm.psort=1;
        }else if(order == 'descending'){  //倒序
          this.searchForm.psort=0;
        }
        this.listExamInit();
      },

      viewExamAnswer(index,row){
        if(this.$storejs.get(process.env.APPKEY + 'token') == undefined){
          this.$alert('请刷新检查登陆状态', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push("/");
            }
          });
          return false;
        }
        let viewWindow = window.open("",'viewWindow');
        getViewExamAnswerUrl({userId: this.userInfo.id,examId:row.id}).then((response) => {
          viewWindow.location = response.data;
        })
      },

      /****************************************************开始练习的方法*****************************************************/
      beginExam(index,row){
        if(this.$storejs.get(process.env.APPKEY + 'token') == undefined){
          this.$alert('请刷新检查登陆状态', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push("/");
            }
          });
          return false;
        }

        let newWindow = window.open("",'practiceOnly');

        examWindow = newWindow;
        validateUserCreditBindingTerm({
          trainingIds:row.trainingStatus,
          userId: this.userInfo.id,
        }).then((response) => {
          if(response.data == false ){
            newWindow.close()
            this.showLearnCardBind = true;
          }else{
            getServerNowTime().then((response)=> {
              var nowDate = new Date(response.data);
              var begin = new Date(row.startTime.replace(/\-/g, "\/"));
              //比较 练习开始时间与当前服务器时间
              if(nowDate < begin){
                newWindow.close()
                this.$alert('暂未到考试开始时间', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
                return false;
              }

              if(row.repeatTimes > row.examCount){
                newWindow.close()
                this.$alert('已超过考试次数', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
                return false;
              }else if( row.repeatTimes == row.examCount && row.userStatus == 1) {
                var examUrl;
                if(row.type == 1){
                  examUrl=process.env.ZHUNBEI_EXAM_URL;
                  if(row.typeDetail == 3){
                    examUrl=process.env.YSDK_EXAM_URL;
                  }else if(row.typeDetail == 103){
                    examUrl=process.env.YSDKMN_EXAM_URL;
                  }else if(row.typeDetail == 105){
                    examUrl=process.env.ZHUNBEI_MONI_EXAM_URL;
                  }
                  newWindow.location = examUrl;
                }else{
                  getBeginExamUrl({userId: this.userInfo.id,examId:row.id,Eurl: window.location.href }).then((response) => {
                    newWindow.location = response.data;
                  })
                }
              }else{
                var param = {trainingStatus:row.trainingStatus,userId:this.userInfo.id};
                validateTrainingExam(param).then((res) => {
                  if(res.data.data.state ==1 ){   // 培训班关联考试设置为 未学习才能考 但该用户已经学习
                    newWindow.close()
                    this.$message({
                      type: 'info',
                      message: '该考试在培训班中要求未学习才能考试，但该学员已经学习！不能再考本场考试！'
                    });
                    newWindow.close()
                  }else if(res.data.data.state ==2 ){
                    newWindow.close()
                    this.$message({
                      type: 'info',
                      message: '您尚未完成课程学习，暂不能开始考试！'
                    });
                    newWindow.close()
                  }else if(res.data.data.state ==-1 ){
                    newWindow.close()
                    this.$message({
                      type: 'info',
                      message: '操作失败，请稍后再试！'
                    });
                    newWindow.close()
                  }else {
                    var examUrl;
                    if(row.type == 1){
                      examUrl=process.env.ZHUNBEI_EXAM_URL;
                      if(row.typeDetail == 3){
                        examUrl=process.env.YSDK_EXAM_URL;
                      }else if(row.typeDetail == 103){
                        examUrl=process.env.YSDKMN_EXAM_URL;
                      }else if(row.typeDetail == 105){
                        examUrl=process.env.ZHUNBEI_MONI_EXAM_URL;
                      }
                      newWindow.location = examUrl;
                    }else{
                      getBeginExamUrl({userId: this.userInfo.id,examId:row.id,Eurl: window.location.href }).then((response) => {
                        newWindow.location = response.data;
                      })
                    }
                  }
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '验证失败！'
                  });
                  newWindow.close()
                });
              }
            }).catch((error)=> {
              newWindow.close()
            })
          }
        })
      },

      formatScore: (row, column)=> {
        if(row.highestScore == ''  || row.highestScore ==null || row.highestScore == undefined)
          return '-' ;
        else
          return row.highestScore ;
      },
      formatCount: (row, column)=> {
        return row.repeatTimes+"/"+row.examCount ;
      },

      formatState: (row, column)=> {
        var testStateName;
        if(row.examState == 0){
          testStateName="未开始";
        }else if(row.examState == 1){
          testStateName="可开考";
        }else if(row.examState == 2){
          testStateName="已完成";
          if(row.userStatus == 1){
            testStateName="考试中";
          }
        }else if(row.examState == 3){
          testStateName="已结束";
        }
        return testStateName;
      },

      formatType: (row, column)=> {
        var testTypeName;
        if(row.terminalType == 1){
          testTypeName="手机/电脑";
        }else if(row.terminalType == 2){
          testTypeName="手机";
        }else if(row.terminalType == 3){
          testTypeName="电脑";
        }
        return testTypeName;
      },

      formatTime: (row, column)=> {
        return row.startTime +"至"+ row.endTime ;
      },

    },
    mounted () {
      this.getTrainingNameList();
      this.listExamInit();

      window.addEventListener("storage", (e) => {
        examWindow.close();
        this.listExamInit();
      });
    },
    watch: {
      bindType: function () {
        this.listExamInit();
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/ExamTablePage.vue